import { render } from "./counter.vue?vue&type=template&id=1c2b3260&scoped=true"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"

import "./counter.vue?vue&type=style&index=0&id=1c2b3260&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2b3260"]])

export default __exports__